export enum ResultActionState {
  ADD = 'ADD',
  EDIT = 'EDIT',
}

export type CustomizeResultImage = {
  groupId: string;
  imageToCustomize: string;
};
